import React from 'react'
import _ from 'lodash'
import classNames from 'classnames'

export class Budget extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isVisible: false
        }

        _.bindAll(this,
            'calculateTotal',
            'togglePopUp',
            'showBooking'
        )
    }

    togglePopUp() {
        if (this.state.isVisible) {
            this.setState({isVisible: false})
        } else {
            this.setState({isVisible: true})
        }    
    }

    showBooking() {
        this.togglePopUp()
        this.props.onToggleBooking()
    }

    // Working from per diem * day length
    calculateTotal() {
        let total = 0
        this.props.legs.map((leg, index) => {
            if (leg.getIn(['destination', 'price_range', 'medium'])) {
                total += (leg.getIn(['properties', 'end']) - leg.getIn(['properties', 'start'])) * leg.getIn(['destination', 'price_range', 'medium'])
            }
        })
        // round an decimals (Not sure if needed, but just in case)
        total = Math.round(total)
        // Uncomment to round to the nearest 10
        // total = Math.ceil(total / 10) * 10;
        if (total > 0) {
            return <div className="budget-total">from <span className="currency">$</span><span>{total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span></div>
        } else {
            return <div className="budget-total">Not enough information</div>
        }
    }

    render() {
        let popClass = classNames(
            'widget-popup',
            {'active': this.state.isVisible}        
        )
        return (
            <div id="budget-container">
                <h2>Instant Quote</h2>
                <div id="budget-popup-wrapper" className="widget-popup-wrapper">
                    <i className="icon-payment" onClick={() => {this.togglePopUp()}}/>
                    <div id="budget-popup" className={popClass}>
                        <i className="icon-close" onClick={() => {this.togglePopUp()}}/>
                        <div className="budget-content">
                            <div>
                  This quote reflects the trip items from your itinerary. The prices listed are best estimates. You can refine the estimate by reviewing each section of the quote on the booking page, or have Luna complete the details for you.
                            </div>
                            <div className="btn btn-medium" onClick={() => {this.showBooking()}}>
                  Request Quote
                            </div>
                        </div>
                    </div>
                </div>
                { this.calculateTotal() }       
            </div>
        )
    }
}